
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/property-managers",
      function () {
        return require("private-next-pages/property-managers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/property-managers"])
      });
    }
  